import { useIsMaster } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useOpenProjectTemplatesModal } from '../../../utils/routes/modals/modalsActions'
import { useProjects } from './_load/ProjectsListLoader'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Panel from '../../../packages/kiti/components/structure/Panel'
import ProjectsListItem from './ProjectListItem'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text from '../../../packages/kiti/components/presentation/Text'

const ProjectsGrid = () => {
  const { t } = useTranslation('projects')
  const projects = useProjects()
  const openProjectTemplatesModal = useOpenProjectTemplatesModal()
  const canAddProject = useIsMaster()

  return (
    <>
      <Grid paddingGutter={0.4} wrap>
        {canAddProject && (
          <Col width="25%">
            <Panel
              borderStyle="dashed"
              align="center"
              justify="center"
              height={11}
              onClick={() => openProjectTemplatesModal()}
            >
              <Icon name="BsPlusSquareDotted" color="dark3" />
              <Separator weight={2} />
              <Text bold color="dark3">
                {t('project.new')}
              </Text>
            </Panel>
          </Col>
        )}

        {projects.map(project => (
          <ProjectsListItem key={project.id} project={project} />
        ))}
      </Grid>
    </>
  )
}

export default ProjectsGrid
